import React from 'react';
import styled from 'styled-components';

import { ScreenProps } from '@front/web-ui/src/components/screen/screen';
import { ScreenContainer } from '@front/web-ui/src/components/screen/container/container';
import { ScreenHeader } from '@front/web-ui/src/components/screen/header/header';
import Title from '@front/web-ui/src/components/base-text/variants/title';
import Text from '@front/web-ui/src/components/base-text/variants/text';
import { minWidth } from '@front/web-ui/src/styles/mixins';
import { SubtitleContainer } from '@front/web-ui/src/components/screen/subtitle-container/subtitle-container';

const StyledTitle = styled(Title.MD)`
  margin: 0;
`;

export const StyledScreenContainer = styled(ScreenContainer)`
  padding: 20px;
  ${minWidth.md`
    padding: 30px;
  `};
`;

export const Screen = ({ title, text, className, children, testID }: ScreenProps) => (
  <StyledScreenContainer className={className} data-testid={testID}>
    {title || text ? (
      <ScreenHeader>
        {!!title && <StyledTitle htmlTag='h1'>{title}</StyledTitle>}
        {!!text && (
          <SubtitleContainer data-testid='subtitle'>
            <Text>{text}</Text>
          </SubtitleContainer>
        )}
      </ScreenHeader>
    ) : null}
    {children}
  </StyledScreenContainer>
);
